export default class Constants {
  static get API_BASE_URL() {
    return window.API_BASE_URL;
  }
  static get DOWNLOAD_BASE_URL() {
    return window.DOWNLOAD_BASE_URL;
  }
  static get APP_NAME() {
    return window.APP_NAME;
  }
}
